/** @format */

import { Card, CardContent, Grid } from "@mui/material";
import mandiriLogo from "../../assets/bank/mandiri.png";
import TextFormatter from "../../utils/TextFormatter";
import moment from "moment";

export default function BillingInvoice() {
  return (
    <Card style={{ height: "100%" }}>
      <CardContent
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <div style={{ flex: 1 }}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item md={6}>
              <h5 style={{ marginBottom: 0, paddingBottom: 0 }}>
                <b>Invoice</b>
              </h5>
              <p>
                <b>INV/INF/001</b>
              </p>
            </Grid>
            <Grid
              item
              md={6}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <p>{new moment().format("DD-MM-YYYY hh:mm:ss")}</p>
            </Grid>
          </Grid>
          <h5 style={{ marginBottom: 0, paddingBottom: 0 }}>
            Summary Purchase
          </h5>
          <div
            style={{
              marginTop: 10,
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div style={{ fontSize: "0.9em", color: "grey", flex: 1 }}>
              Credits
            </div>
            <div style={{ fontSize: "0.9em", color: "grey" }}>
              <b>{TextFormatter.moneyFormatter(1000000)}</b>
            </div>
          </div>
          <div
            style={{
              marginTop: 5,
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div style={{ fontSize: "0.9em", color: "grey", flex: 1 }}>
              Tax (11%)
            </div>
            <div style={{ fontSize: "0.9em", color: "grey" }}>
              <b>{TextFormatter.moneyFormatter(Math.round(1000000 * 0.11))}</b>
            </div>
          </div>
          <div
            style={{
              height: 1,
              width: "100%",
              marginTop: 10,
              marginBottom: 10,
              backgroundColor: "lightgray",
            }}
          ></div>
          <div
            style={{
              marginTop: 5,
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div style={{ fontSize: "0.9em", flex: 1 }}>
              <b>Total Amount</b>
            </div>
            <div style={{ fontSize: "0.9em" }}>
              <b>{TextFormatter.moneyFormatter(Math.round(1000000 * 1.11))}</b>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              color: "grey",
              alignItems: "flex-start",
            }}
          >
            <b
              style={{
                fontSize: "1.1em",
                marginTop: 30,
                marginBottom: 10,
              }}
            >
              Contact Information
            </b>

            <b>Zeman Mustohid</b>
            <div>zaemanmustohid21@gmail.com</div>
            <div>PT. Infomedia Nusantara</div>
            <div>Jl. Fatmawati Jakarta Selatan</div>

            <b style={{ fontSize: "1.1em", marginTop: 30 }}>Payment Method</b>
            <div style={{ fontSize: "0.85em" }}>Virtual Account</div>
            <img
              style={{ objectFit: "contain", height: 50 }}
              src={mandiriLogo}
              alt="mandirilogo2"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
